export default "__VITE_ASSET__CFj7PwGB__"